<template>
	<div
			v-if="open"
			class="info-box"
			:style="style"
	>
		<slot/>
	</div>
</template>

<script>
	export default {
		name: "FloatingInfoBox",
		props: ['open', 'conf', 'offset'],
		computed: {
			style() {
				if (this.conf) {
					if (this.offset) {
						return {
							left: this.conf.left + this.offset.left + 'px',
							top: this.conf.top + this.offset.top + 'px',
							width: this.conf.width + 'px'
						}
					}

					return {
						left: this.conf.left + 'px',
						top: this.conf.top + 'px',
						width: this.conf.width + 'px'
					}
				}

				return {};
			}
		}
	}
</script>

<style lang="scss" scoped>
	.info-box {
		position: absolute;
		top: 0;
		left: 0;
		background: #ffffff;
		border: 1px solid #000000;
		display: inline-block;
		padding: 0.5rem;
		box-sizing: border-box;
		z-index: 4;
	}
</style>